/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import SaveButton from '../../../components/common/SaveButton';
import Form from 'saur_ui_library/src/Atoms/Input/Form/Form';
import ModernDatePicker from '../../../components/common/component/ModernDatePicker';
import { dateFr, loaderDataComponent } from '../../../utils/helper';
import {
  inputTextDate,
  transformDate,
} from '../../../utils/helpers/view/detailsHelper';
import { InputSwitch } from 'primereact/inputswitch';
import { InputNumber } from 'primereact/inputnumber';
import { createGlobalStyle } from 'styled-components';
import { formBcParamsType } from '../../../utils/Interface';
import { CollectionPoolApi } from '../../../utils/api';
import { getParamsEnvironment } from '../../../utils/helpers/apiHelper';
import ErrorParameter from '../../../components/common/ErrorParameter';

function IndicatorParams() {
  const collectionPoolId = window.sessionStorage.getItem('collectionPoolId');
  const [collectionPoolSummary, setCollectionPoolSummary] = useState<any>();
  const [form, setForm] = useState<formBcParamsType>({
    id: collectionPoolSummary?.id,
    collectionPoolId: collectionPoolSummary?.collectionPoolId,
    blackPointCount: collectionPoolSummary?.blackPointCount,
    indusSensitive: collectionPoolSummary?.indusSensitive,
    rainDumpSensitive: collectionPoolSummary?.rainDumpSensitive,
    h2SDryPeriodStartDate: collectionPoolSummary?.h2SDryPeriodStartDate,
    h2SDryPeriodEndDate: collectionPoolSummary?.h2SDryPeriodEndDate,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  // Submit form function
  const handleOnSubmit = () => {
    const startDate = inputTextDate(form?.h2SDryPeriodStartDate);
    const endDate = inputTextDate(form?.h2SDryPeriodEndDate);
    const promise = CollectionPoolApi.updateCollectionPoolSummary(
      parseInt(collectionPoolId as string),
      {
        ...form,
        h2SDryPeriodStartDate: startDate,
        h2SDryPeriodEndDate: endDate,
      },
    );
    getParamsEnvironment(
      promise,
      setCollectionPoolSummary,
      setLoading,
      setError,
    );
  };

  useEffect(() => {
    const promise = CollectionPoolApi.getCollectionPoolSummary(
      parseInt(collectionPoolId as string),
    );
    getParamsEnvironment(
      promise,
      setCollectionPoolSummary,
      setLoading,
      setError,
    );
  }, []);

  useEffect(() => {
    setForm(collectionPoolSummary);
  }, [collectionPoolSummary]);
 
  return (
    <>
      <Form className='prams-form' onSubmit={handleOnSubmit}>
        <Styles />
        <Word
          className='subtitle'
          value='Veuillez définir vos seuils pour le bassin de collecte'
        />
        <Container className='h2s'>
          <Word className='module-title' value='H2S' />
          <Word value='Période sèche :' />
          <Container className='date-inputs'>
            <Container className='startDate-container'>
              <Word value='Mois de début' />
              <ModernDatePicker
                className='datePickFrom'
                inputPlaceholder='Mois de début'
                value={
                  form?.h2SDryPeriodStartDate &&
                  typeof form?.h2SDryPeriodStartDate === 'string' ?
                  transformDate(form?.h2SDryPeriodStartDate) : form?.h2SDryPeriodStartDate
                }
                shouldHighlightWeekends
                formatInputText={() => {
                  return inputTextDate(form?.h2SDryPeriodStartDate);
                }}
                locale={dateFr}
                onChange={(date: any) => {
                  setForm((oldValues) => {
                    return { ...oldValues, h2SDryPeriodStartDate: date };
                  });
                }}
              />
            </Container>
            <Container>
              <Word value='Mois de fin' />
              <ModernDatePicker
                className='datePickFrom'
                inputPlaceholder='Mois de fin'
                value={
                  form?.h2SDryPeriodEndDate &&
                  typeof form?.h2SDryPeriodStartDate === 'string' ?
                  transformDate(form?.h2SDryPeriodEndDate) : form?.h2SDryPeriodEndDate
                }
                shouldHighlightWeekends
                formatInputText={() => {
                  return inputTextDate(form?.h2SDryPeriodEndDate);
                }}
                locale={dateFr}
                onChange={(date: any) => {
                  setForm((oldValues) => {
                    return { ...oldValues, h2SDryPeriodEndDate: date };
                  });
                }}
              />
            </Container>
          </Container>
        </Container>

        <Container className='hydro'>
          <Word className='module-title' value='HYDRO' />
          <Word value='Bassin de collecte très sensible si nombre de points noirs supérieur à :' />
          <InputNumber
            className='input-number'
            id='input-number'
            value={form?.blackPointCount}
            onValueChange={(v: any) =>
              setForm((oldValues) => {
                return { ...oldValues, blackPointCount: v.target.value };
              })
            }
            // mode='decimal'
            // minFractionDigits={4}
          />
        </Container>
        <Container className='indus'>
          <Word className='module-title' value='INDUS' />
          <Word value='Bassin de collecte très sensible :' />
          <Container className='switch-container'>
            <Word value='Non' />
            <InputSwitch
              className='hydro-input-switch'
              checked={form?.indusSensitive}
              onChange={(e) =>
                setForm((oldValues: any) => {
                  return { ...oldValues, indusSensitive: e.value };
                })
              }
            />
            <Word value='Oui' />
          </Container>
        </Container>
        <Container className='pluie'>
          <Word className='module-title' value='PLUIE' />
          <Word value='Bassin de collecte très sensible aux déversement :' />
          <Container className='switch-container'>
            <Word value='Non' />
            <InputSwitch
              checked={form?.rainDumpSensitive}
              onChange={(e) =>
                setForm((oldValues: any) => {
                  return { ...oldValues, rainDumpSensitive: e.value };
                })
              }
            />
            <Word value='Oui' />
          </Container>
        </Container>
        {loaderDataComponent(loading)}
        {loading === false && <SaveButton />}
        {error && (
          <ErrorParameter
            message="une erreur s'est produite. Veuillez réessayer"
            title=''
            IsVisible={true}
          />
        )}
      </Form>
    </>
  );
}

const Styles = createGlobalStyle`
.sds-reset-style{
.prams-form{
  display: flex;
  flex-direction: column;
.subtitle{
  text-align: center;
}
.module-title{
  font-weight:  700;
  line-height: 19px;
  margin-bottom: 15px;
  margin-top: 10px;
}
.switch-container{
  display: flex;
    flex-direction: row;
    margin-top: 10px;
    margin-bottom: 10px;
}
.h2s{
  .date-inputs{
    display: flex;
    flex-direction: row;
    margin-top: 15px;
    .startDate-container{
      margin-right: 30px;
    }
  }
}
.hydro{
  .input-number {
    width: 90px;
    margin-top: 15px;
      input{
            background-color: rgb(255, 255, 255);
            border: 1px solid rgb(204, 232, 246);
            border-radius: 5px;
            width: 95px;
            height: 55px;
            text-align: center;
      }
  }
}
.p-inputswitch{
    width: 48px;
    height: 28px;
    margin-right: 10px;
    margin-left: 10px;
   .p-inputswitch-slider:before {
    width: 20px;
    height: 20px;
    left: 4px;
    margin-top: -10px;
    }
  }
  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
    -webkit-transform: translateX(18px);
    transform: translateX(18px);
  }
  .sds-m-modern-date-picker{
    margin-bottom: 15px !important;
  }
  .saveButton{
    align-items: center;
    margin-bottom: 20px;
  }
}
}`;
export default React.memo(IndicatorParams);
